import { SlimFrame } from "@/common/CommonType";
import { IFrame, IWardrobeWithProduct } from "@/common/WardrobeTypes";

export interface FrameMigrationConfig {
  oldNewFrameIdMap: Record<string, number> | null;
  allFrames: SlimFrame[];
}

// Keep instance IDs and their door/interior references; replace only frame products.
export const normalizeFrameId = (
  frame: IFrame,
  { oldNewFrameIdMap, allFrames }: FrameMigrationConfig
): IFrame => {
  const newFrameId = oldNewFrameIdMap?.[String(frame.frameId)];
  if (newFrameId === undefined || newFrameId === frame.frameId) return frame;

  const newFrame = allFrames.find((item) => item.frameId === newFrameId);
  // Never display/save a partially migrated wardrobe when configuration is incomplete.
  if (!newFrame) throw new Error(`找不到替换柜体：${frame.frameId} → ${newFrameId}`);

  return {
    ...frame,
    frameId: newFrame.frameId,
    frameProductId: newFrame.productId,
    frameProducts: newFrame.itemNoLocal,
    color: newFrame.frameColor,
    modelUrl: newFrame.modelUrl,
    imageUrl: newFrame.imageUrl,
    width: newFrame.width,
    height: newFrame.height,
    depth: newFrame.depth,
    templateId: "",
  };
};

export const normalizeFrameIds = (
  wardrobe: IWardrobeWithProduct,
  config: FrameMigrationConfig
): IWardrobeWithProduct => {
  let changed = false;
  const frames = wardrobe.frames.map((frame) => {
    const normalizedFrame = normalizeFrameId(frame, config);
    if (normalizedFrame !== frame) changed = true;
    return normalizedFrame;
  });

  return changed ? { ...wardrobe, frames, templateId: "" } : wardrobe;
};
